import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import DeleteButton from "../../common/DeleteButton";
import ThreeDot from "../../common/ThreeDot";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import {
  deleteDesignRate,
  getAllDesignRates,
} from "../../../services/ratediary.service";
import EditButton from "../../common/EditButton";
import ViewDetailsButton from "../../common/ViewDetailsButton";


export default function DesignList() {
  const [selectedDesigns, setSelectedDesigns] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const navigate = useNavigate();
  const { token } = useSelector((state) => state?.auth);
  const [rateDiary, setRateDiary] = useState([]);
  const [next, setNext] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(null);
  const itemsPerPage = 10;
  const [totalPages, setTotalPages] = useState(1);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const product_id = queryParams.get("product_id");
  const backPage = queryParams.get("page");
  const search = queryParams.get("search");

  const fetchRateDiary = async (product_id, page = 1) => {
    try {
      const params = { product_id, page };
      const res = await getAllDesignRates(token, params);
      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        setRateDiary(res?.data?.results || []);
        setNext(res?.data?.next);
        setPrevious(res?.data?.previous);
        setCurrentPage(page);
        setTotalEntries(res?.data?.count || null);
        setTotalPages(Math.ceil((res?.data?.count || 0) / itemsPerPage));
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch design id. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching rate diary:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const startEntry = (currentPage - 1) * itemsPerPage + 1;
  const endEntry = Math.min(currentPage * itemsPerPage, totalEntries);

  useEffect(() => {
    if (product_id) {
      fetchRateDiary(product_id, currentPage);
    }
  }, [product_id, currentPage]);

  const handleDelete = async (DesignID, ratediaryid) => {
    try {
      const res = await deleteDesignRate(token, ratediaryid);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire(
          "Deleted!",
          `${DesignID} Design rate has been deleted successfully.`,
          "success"
        ).then(() => {
          if (product_id) {
            const remainingItems = rateDiary.length - 1;
            if (remainingItems === 0 && currentPage > 1) {
              setCurrentPage(currentPage - 1);
              fetchRateDiary(product_id, currentPage - 1);
            } else {
              fetchRateDiary(product_id, currentPage);
            }
          }
        });
      } else {
        Swal.fire(
          "Error",
          res?.data?.detail ||
            "Failed to delete the product. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during product deletion:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const handleCheckboxChange = (design) => {
    setSelectedDesigns((prevSelected) => {
      const isSelected = prevSelected.some(
        (d) => d.design_id === design.design_id
      );
      if (isSelected) {
        return prevSelected.filter((d) => d.design_id !== design.design_id);
      } else {
        return [...prevSelected, design];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedDesigns([]);
    } else {
      setSelectedDesigns(rateDiary);
    }
    setSelectAll(!selectAll);
  };

  const handleGenerateBarcodes = () => {
    if (selectedDesigns.length === 0) {
      alert("Please select at least one design to generate barcodes.");
    } else {
      navigate(`/products/designs/genrated-barcode?page=${backPage}${
          search ? `&search=${search}` : ""
        }`, {
        state: { selectedDesigns },
      });
    }
  };



  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="form-head d-flex mb-3 align-items-start justify-content-between">
          {/* <div className="input-group search-area d-inline-flex">
            <input
              type="text"
              className="form-control"
              placeholder="Search here"
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <i className="fas fa-search"></i>
              </span>
            </div>
          </div> */}
          <div className="m-4 p-1"></div>
          <div className="d-flex align-items-center">
            {/* Generate Barcode button */}
            <button
              className="btn btn-primary px-3 py-2 me-3 mt-3 add-btn sticky-btn3"
              onClick={handleGenerateBarcodes}
              title="Generate Barcodes"
            >
              Generate Barcodes
            </button>
            {/* Back button aligned at the end */}
            <Link
              to={`/products?page=${backPage}${
                search ? `&search=${search}` : ""
              }`}
              className="ms-auto"
            >
              <img
                src="/assets/images/kidskart/icon/back-button.png"
                alt="Back"
                className="mt-3 me-3"
              />
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-xxl-12 col-lg-12 col-sm-12">
            <div className="card">
              <div className="card-body p-0">
                {rateDiary && rateDiary.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table order-request2 order-request3">
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              onChange={handleSelectAll}
                              checked={
                                rateDiary.length > 0 &&
                                selectedDesigns.length === rateDiary.length
                              }
                            />
                          </th>
                          <th>Design</th>
                          <th>Color</th>
                          <th>Size</th>
                          <th>Design ID</th>
                          <th>Rate</th>
                          <th>Stock</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rateDiary.map((item) => (
                          <tr
                            key={item.rate_diary_id}
                            style={{ height: "70px" }}
                          >
                            <td>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectedDesigns.some(
                                  (d) => d.design_id === item.design_id
                                )}
                                onChange={() => handleCheckboxChange(item)}
                              />
                            </td>
                            <td>{item.design_number || "N/A"}</td>
                            <td>{item.colors?.join(", ") || "N/A"}</td>
                            <td>{item.size_name || "N/A"}</td>
                            <td>{item.design_id || "N/A"}</td>
                            <td>
                              ₹
                              {(item.design_rate * 1)?.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) || "N/A"}
                            </td>
                            <td>{item.stock}</td>
                            <td>
                              <div className="d-flex align-items-center">
                                {item.stock > 0 ? (
                                  <Link className="btn btn-success light btn-sm py-2">
                                    IN STOCK
                                  </Link>
                                ) : (
                                  <Link className="btn btn-danger light btn-sm py-2">
                                    OUT OF STOCK
                                  </Link>
                                )}
                                <div className="dropdown ms-auto c-pointer">
                                  <ThreeDot />
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <EditButton
                                      to={`/products/designs/update`}
                                      id={item.rate_diary_id}
                                    />
                                    <DeleteButton
                                      name={`${item.design_id} Rate Diary Design ID`}
                                      onDelete={() =>
                                        handleDelete(
                                          item.design_id,
                                          item.rate_diary_id
                                        )
                                      }
                                    />
                                    <ViewDetailsButton
                                      to={`/products/designs/details`}
                                      id={item.rate_diary_id}
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                        {rateDiary.length < 5 ? (
                          <tr style={{ height: "205px" }}></tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="my-5 py-5 text-center fs-4 fw-bold">
                    Please Add Design number
                  </div>
                )}
              </div>
            </div>

            {/* Pagination Info */}
            {totalEntries && totalEntries > 10 && (
              <div className="dataTables_wrapper no-footer">
                <div className="dataTables_info">
                  Showing {startEntry} to {endEntry} of {totalEntries} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <button
                    className={`btn btn-primary me-2 ${
                      !previous && "disabled"
                    }`}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                  <span>
                    {(() => {
                      const maxVisible = 7;
                      const pages = Array.from(
                        { length: totalPages },
                        (_, i) => i + 1
                      );
                      let start = Math.max(
                        currentPage - Math.floor(maxVisible / 2),
                        1
                      );
                      let end = start + maxVisible - 1;

                      if (end > totalPages) {
                        end = totalPages;
                        start = Math.max(end - maxVisible + 1, 1);
                      }

                      return pages.slice(start - 1, end).map((page) => (
                        <button
                          key={page}
                          className={`btn btn-sm mx-1 ${
                            currentPage === page
                              ? "btn-dark"
                              : "btn-outline-dark"
                          }`}
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      ));
                    })()}
                  </span>
                  <button
                    className={`btn btn-primary ms-2 ${!next && "disabled"}`}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
